import { profileFormEvents } from "../../../profile/hooks/profileFormEvents";

/**
 * Notifies RN profile surfaces that profile data has changed. This triggers
 * ProfileTabContainer refetches.
 *
 * This is the cross-surface invalidation seam of the shared resume-save module:
 * call it after a batch of resume-save mutations so every surface reading the
 * profile re-fetches.
 */
export function notifyProfileDataChanged(): void {
  profileFormEvents.emit("rnFormCompleted");
}
